
import { css } from 'lit';
export default css`
:host{
  display:inline-flex;
  flex-wrap:wrap;
  align-items:center;
  gap:var(--spacing-2);
  gap:var(--detail-gap, var(--spacing-2));
  font-weight:var(--fw-medium);
  font-size:var(--fs-eyebrow-mobile);
  line-height:var(--lh-eyebrow-mobile);
  line-height:var(--detail-line-height-mobile, var(--lh-eyebrow-mobile));
  font-family:var(--ff-body);
  letter-spacing:var(--ls-eyebrow);
  text-transform:uppercase;
}
  @media print{:host{
    font-size:var(--fs-base);
    color:var(--neutral-charcoal)
}
  }

::slotted(.comma){
  margin-left:calc(var(--spacing-2) * -1);
}

@media (min-width: 768px){
  :host{
    font-size:var(--fs-eyebrow);
    line-height:var(--lh-eyebrow);
    line-height:var(--detail-line-height, var(--lh-eyebrow));
  }
}
`;